import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-grid-system';

import { useBrand } from '../_libs/hooks/useBrand';
import { useData } from '../_libs/hooks/useData';

import DataColumn from '../atoms/DataColumn';
import Loader from '../molecules/Loader';

const MSG_TIME = 4000; // milliseconds loading message will stay on screen

const PDFLoader = (): JSX.Element => {
  const { topThemes } = useData();
  const { primaryBrand } = useBrand();
  const [messageIndex, setMessageIndex] = useState(0);
  const [loaderIsComplete, setLoaderIsComplete] = useState(false);

  // 22-11-01: Messages via FY23Q2 JCL Loader Content https://docs.google.com/spreadsheets/d/1xLnl9_ryOxXPClUJLLEQQzsmD2ZFFzV3dr40up1YAzM/edit#gid=0
  const messages = [
    'Matching AI-generated faces with community demographics to increase identity alignment.',
    `Creating ${topThemes.length * 9} community-specific materials for print and digital distribution.`,
    'Preparing literature on potential health equity barriers for clinical reference.',
  ];

  useEffect(() => {
    if (messageIndex === messages.length) {
      setLoaderIsComplete(true);
    } else {
      setTimeout(() => {
        setMessageIndex(messageIndex + 1);
      }, MSG_TIME);
    }
  }, [messageIndex]);

  return (
    !loaderIsComplete &&
      <Row className="mt-4" style={{
        height: '90vh',
        marginBottom: '10vh',
      }}>
        <Col>
          <DataColumn style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}>
            <div className="pa-4 f-sans t-center">
              <Loader primaryColor={primaryBrand.colors.primary} />
              <h4>Compiling Health Equity Toolkit</h4>
              <div>
                { messages[messageIndex] }
              </div>
            </div>
          </DataColumn>
        </Col>
      </Row>
    );
};

export default PDFLoader;
